'use client';

import { Currency } from '@prezly/sdk';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { usePricingPageContext } from '@/pricing/PricingPageContext';

interface Props {
    prices: string; // "eur=50, usd=60"
}

interface PricesMap {
    eur: string;
    usd: string;
}

export function PriceRenderer({ prices }: Props) {
    const pathname = usePathname();
    const isPricingPage = pathname.startsWith('/pricing');

    const pricesMap: PricesMap = Object.fromEntries(
        prices
            .trim()
            .split(/[\s,;]/)
            .map((pair) => pair.split('=')),
    );

    return isPricingPage ? (
        <PricingPageCurrencyPrice prices={pricesMap} />
    ) : (
        <IpCurrencyPrice prices={pricesMap} />
    );
}

function PricingPageCurrencyPrice({ prices }: { prices: PricesMap }) {
    const { currency } = usePricingPageContext();
    const isEuro = currency === Currency.EUR;

    return isEuro ? `${prices.eur}€` : `$${prices.usd}`;
}

function IpCurrencyPrice({ prices }: { prices: PricesMap }) {
    const [currency, setCurrency] = useState(Currency.USD);
    const isEuro = currency === Currency.EUR;

    useEffect(() => {
        fetch('/api/get-currency', { cache: 'force-cache' })
            .then((response) => response.json())
            .then((response) => {
                setCurrency(response.currency);
            });
    }, []);

    return isEuro ? `${prices.eur}€` : `$${prices.usd}`;
}
